module.exports = __webpack_public_path__ + "img/android-chrome-512x512.ea9be802.png";